import { useEffect } from 'react';
import { useSubscriptionInternal } from './internal/use-subscription-internal';
export function useSubscription(input$, observerOrNext$, error, complete) {
    return useSubscriptionInternal(useEffect, [
        input$,
        observerOrNext$,
        error,
        complete
    ]);
}
//# sourceMappingURL=use-subscription.js.map